<script>
  import _base from '../../_default/components/_base.vue'
  import {
    gerarRelatorioEntradas,
    gerarRelatorioEstoque,
    gerarRelatorioFinanceiro,
    gerarRelatorioInventario,
    gerarRelatorioLeiloeiro,
    gerarRelatorioPrestacaoDeContas,
    gerarRelatorioPrestacaoDeContasEntradas,
    gerarRelatorioPrestacaoDeContasPatio,
    gerarRelatorioRelacionados,
    gerarRelatorioSaidas,
    gerarRelatorioTransferidosPatioCentral,
    gerarRelatorioVendasPorArrematantes,
    gerarRelatorioBloqueadosLeilao,
    getBasicData
  } from '../../../domain/relatorios/services/relatorios-gerenciais'
  import ImportProgress from '../documentos/components/ImportProgress'
  import {VueMaskDirective as mask} from 'v-mask'
  import {isValidDate} from '../../../utils/helpers/validators'
  import moment from 'moment'
  import {getPatiosPorTipo} from '../../../domain/grv/helpers/tipos-grv'
  import createDownloadLink from '../../../utils/create-download-link'
  import {configuracoesContratos} from './configuracoes-contratos/configuracoes-contratos'
  import menuRelatorios from './menu-relatorios'
  import AclCheckMixins from '../../_default/components/mixins/AclCheckMixins'

  let previousDate = moment().add(-1, 'month')
  let Meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

  export default {
    name: 'RelatoriosGerenciais',
    extends: _base,
    mixins: [AclCheckMixins],
    components: {
      ImportProgress
    },
    directives: {mask},
    data () {
      return {
        menuRelatorios,
        tipo: 1,
        graphLoaded: false,
        isLoading: false,
        loadPercent: 0,
        showMenuBtn: true,
        data: null,
        data1: null,
        data2: null,
        mes1: String(previousDate.format('M')),
        ano1: String(previousDate.format('YYYY')),
        mes2: String(moment().format('M')),
        ano2: String(moment().format('YYYY')),
        showOptionsAutocomplete: false,
        selectedLeilao: null,
        selectedPatio: null,
        listaLeiloes: [],
        contratoRelatorio: null
      }
    },
    computed: {
      config () {
        return configuracoesContratos[this.contratoRelatorio].configuracoes
      },
      labelsReport () {
        return configuracoesContratos[this.contratoRelatorio].label
      },
      MENU () {
        return this.config.MENU
      },
      TIPOS_RELATORIO () {
        return this.config.TIPOS_RELATORIO
      },
      GRUPOS_RELATORIO () {
        return this.config.GRUPOS_RELATORIO
      },
      FUNCTIONS () {
        return this.config.FUNCTIONS
      },
      periodo () {
        if (this.data1 === this.data2) return this.data1
        return `${this.data1} a ${this.data2}`
      },
      meses () {
        return Meses
      },
      periodoMeses () {
        return `Período: ${this.meses[parseInt(this.mes1)]}/${this.ano1} a ${this.meses[parseInt(this.mes2)]}/${this.ano2}`
      },
      dataNomeArquivo () {
        const {today, periodo} = this
        return (periodo || today).replace(/\//g, '-').replace(/\s/g, '_')
      },
      today () {
        const date = new Date()
        const day = date.getUTCDate().toString().padStart(2, '0')
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
        const year = date.getUTCFullYear()

        return `${day}/${month}/${year}`
      },
      filteredListaLeiloes () {
        return this.listaLeiloes.map((v) => ({label: v.titulo, value: v.id}))
      },
      patiosComputed () {
        const patiosTp = getPatiosPorTipo(this.contratoRelatorio)
        let patios = (this.patios || []).map((v) => {
          if (patiosTp.includes(v.id)) return {label: v.nome, value: v.id}
        })
        return patios.filter(p => typeof p !== 'undefined')
      }
    },
    watch: {
      'data1' () {
        this.graphLoaded = false
      },
      'data2' () {
        this.graphLoaded = false
      },
      contratoRelatorio () {
        const firstKey = Object.keys(this.TIPOS_RELATORIO)[0]
        this.tipo = this.TIPOS_RELATORIO[firstKey]
      }
    },
    created () {
      this.carregarBasicData()
    },
    mounted () {
      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      this.$root.$el.classList.remove('full-height')
    },
    methods: {
      tipoRelatorio (e, value) {
        this.contratoRelatorio = value
        this.showMenuBtn = false
      },
      startLoading () {
        this.graphLoaded = false
        this.loadPercent = 0
        this.isLoading = true
        this.$interval = window.setInterval(() => {
          if (this.loadPercent >= 100) {
            window.clearInterval(this.$interval)
            this.loadPercent = 100
          } else {
            this.loadPercent = Math.round(this.loadPercent + (Math.random() + 1))
          }
        }, 50)
      },
      stopLoading () {
        window.clearInterval(this.$interval)
        this.isLoading = false
        this.loadPercent = 100
      },
      gerarRelatorioEstoque () {
        /* if (!this.validarIntervaloData()) {
          return
        } */
        this.startLoading()
        gerarRelatorioEstoque('', '', this.contratoRelatorio, this.selectedPatio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_estoque_${this.dataNomeArquivo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioEntradas () {
        if (!this.validarIntervaloData()) return
        this.startLoading()
        gerarRelatorioEntradas(...this.ajustarDatas([this.data1, this.data2]), this.contratoRelatorio, this.selectedPatio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_entradas_${this.dataNomeArquivo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioSaidas () {
        if (!this.validarIntervaloData()) return
        this.startLoading()
        gerarRelatorioSaidas(...this.ajustarDatas([this.data1, this.data2]), this.contratoRelatorio, this.selectedPatio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_saidas_${this.dataNomeArquivo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioBloqueadosParaLeilao () {
        this.startLoading()
        gerarRelatorioBloqueadosLeilao('', '', this.contratoRelatorio, this.selectedPatio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_bloqueados_leilao_${this.dataNomeArquivo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioTransferidosPatioCentral () {
        if (!this.validarIntervaloData()) return
        this.startLoading()
        gerarRelatorioTransferidosPatioCentral(...this.ajustarDatas([this.data1, this.data2]), this.contratoRelatorio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_transf_patio_central_${this.dataNomeArquivo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioRelacionados () {
        this.startLoading()
        const {value: id, label: titulo} = this.selectedLeilao
        gerarRelatorioRelacionados(id)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_relacionados_leilao_${titulo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioVendasPorArrematantes () {
        this.startLoading()
        const {value: id, label: titulo} = this.selectedLeilao
        gerarRelatorioVendasPorArrematantes(id)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_vendas_por_arrematante_${titulo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioFinanceiro () {
        if (!this.validarIntervaloData()) return
        this.startLoading()
        gerarRelatorioFinanceiro(...this.ajustarDatas([this.data1, this.data2]), this.selectedPatio, this.contratoRelatorio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_financeiro_${this.dataNomeArquivo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioPrestacaoDeContasEntradas () {
        this.startLoading()
        gerarRelatorioPrestacaoDeContasEntradas(this.contratoRelatorio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_prestacao_de_contas_entradas.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioPrestacaoDeContasPatio () {
        this.startLoading()
        gerarRelatorioPrestacaoDeContasPatio(this.contratoRelatorio)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_prestacao_de_contas_patio.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioInventario () {
        this.startLoading()
        gerarRelatorioInventario()
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_inventario_${this.dataNomeArquivo}.xls`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioLeiloeiro () {
        this.startLoading()
        const {value: id, label: titulo} = this.selectedLeilao

        gerarRelatorioLeiloeiro(id)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_leiloeiro_emissao_de_notas_${titulo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      gerarRelatorioPrestacaoDeContas () {
        this.startLoading()
        const {value: id, label: titulo} = this.selectedLeilao
        gerarRelatorioPrestacaoDeContas(id)
          .then(response => {
            createDownloadLink(response.data, `relatorio_gerencial_leiloeiro_prestacao_de_contas_${titulo}.csv`)
            this.stopLoading()
          })
          .catch(error => {
            this.stopLoading()
            console.log(error)
          })
      },
      carregarBasicData () {
        getBasicData()
          .then(response => {
            this.listaLeiloes = response.data.leiloes
            this.patios = response.data.patios
          })
          .catch(error => {
            console.log(error)
            alert('Erro ao carregar a lista de leilões')
          })
      },
      validarIntervaloData () {
        if (!isValidDate(this.data1, 'pt-br') || !isValidDate(this.data2, 'pt-br')) {
          alert('Digite um intervalo de datas válido')
          return false
        }
        return true
      },
      gerar () {
        try {
          const nomeFuncao = this.FUNCTIONS.checarFuncao(this.tipo)
          this[nomeFuncao]()
        } catch (e) {
          alert('Esse relatório está indisponível no momento.')
          console.error(e)
        }
      },
      modifyForm () {
        this.graphLoaded = false
      },
      ajustarDatas (datas) {
        return datas.map(item => item.split('/').reverse().join('-'))
      }
    }
  }
</script>

<template>
  <div class="relatorios-basico h-full">
    <div class="header hidden-print row">
      <div class="title col-sm-11"><span>Relatórios Gerenciais</span></div>
      <div class="back col-sm-1"><strong onclick="window.history.back()" class="label bg-info"
          style="font-size:14px; cursor: pointer">Voltar</strong></div>
    </div>
    <div class="content loading" v-if="isLoading">
      <div class="cload">
        <import-progress :percent="loadPercent"></import-progress>
      </div>
    </div>
    <div class="content loading" v-show="!isLoading && !graphLoaded" :style="{ 'justify-content': 'center' }">
      <div class="cload no-select">
        <transition name="slide-fade">
          <div class="m-b-sm grid-container" v-if="showMenuBtn">
            <button v-for="contrato in menuRelatorios" v-if="ACL.check(contrato.acl, currentUser.id)"
              @click="tipoRelatorio($event, contrato.value)" :value="contrato.value"
              :class="`btn ${contrato.color || 'btn-default'} btn-lg grid-item`">
              <i :class="`${contrato.icon} block`"></i>
              {{ contrato.label }}
            </button>
          </div>
          <div key="2" class="m-b-sm" v-else>
            <div class="row">
              <h2 style="margin-bottom:30px">Relatórios {{ labelsReport }}</h2>
            </div>
            <form v-on:submit.prevent="gerar">
              <div class="rel-type row">
                <select v-model="tipo" style="width:100%; height: 50px; font-size: 20px">
                  <optgroup :label="key" v-for="(itens, key) in MENU">
                    <option :value="item.value" v-for="item in itens" :disabled="item.disabled">{{ item.label }}</option>
                  </optgroup>
                </select>
              </div>
              <div class="filters row m-t">
                <div v-if="GRUPOS_RELATORIO.checarGrupo('habilitarFiltroData', tipo)">
                  <div class="text-black">Período:</div>
                  <input v-model="data1" @change="modifyForm" autofocus v-mask="'##/##/####'">
                  <input class="m-l" v-model="data2" @change="modifyForm" v-mask="'##/##/####'">
                </div>

                <div v-if="GRUPOS_RELATORIO.checarGrupo('habilitarFiltroPatio', tipo)">
                  <div class="text-black">Pátio:</div>
                  <select class="form-control" v-model="selectedPatio"
                    title="Não selecione caso não queira uma filtragem por pátio">
                    <option style="font-weight: bold" :value="null">Todos os pátios</option>
                    <option v-for="cat in patiosComputed" :value="cat.value">{{ cat.label }}</option>
                  </select>
                </div>

                <div class="autocomplete-input" v-if="GRUPOS_RELATORIO.checarGrupo('leilao', tipo)">
                  <div class="text-black">Leilão:</div>
                  <v-select :options="filteredListaLeiloes" placeholder="Selecione um leilão"
                    v-model="selectedLeilao"></v-select>
                </div>

                <div class="row m-t">
                  <button type="submit" class="m-l btn btn-default"><b>Gerar&nbsp;<i class="fa fa-search"></i></b></button>
                  <button type="button" class="m-l btn btn-dark" @click="showMenuBtn = !showMenuBtn"><b>Fechar</b></button>
                </div>
              </div>
            </form>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?4576f977